import React from "react";

import { Box, Typography, TypographyProps } from "@mui/material";

export const ParaSmall: React.FC<
  TypographyProps<React.ElementType, { component?: React.ElementType }> & {
    fontWeight?: number;
  }
> = ({ fontWeight = 400, ...otherProps }) => (
  <Typography component="div">
    <Box
      fontSize={10}
      lineHeight={"14.58px"}
      fontWeight={fontWeight}
      letterSpacing={1}
    >
      <Typography variant="inherit" component="p" {...otherProps} />
    </Box>
  </Typography>
);
